import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

/**
 * Icon Error in circle with the red background
 * @param props IconSvgProps
 * @returns React.JSX.Element
 */
export const ErrorPlaneIcon: React.FC<IconSvgProps> = (props) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="12" r="10" fill="#F84B43" />
    <path
      d="M12.9979 12L15.7912 9.20674C15.9238 9.0744 15.9983 8.89483 15.9985 8.70751C15.9987 8.5202 15.9244 8.34049 15.7921 8.20793C15.6597 8.07536 15.4802 8.00079 15.2929 8.00062C15.1055 8.00046 14.9258 8.07471 14.7933 8.20704L12 11.0003L9.20674 8.20704C9.07417 8.07448 8.89437 8 8.70689 8C8.51941 8 8.33961 8.07448 8.20704 8.20704C8.07448 8.33961 8 8.51941 8 8.70689C8 8.89437 8.07448 9.07417 8.20704 9.20674L11.0003 12L8.20704 14.7933C8.07448 14.9258 8 15.1056 8 15.2931C8 15.4806 8.07448 15.6604 8.20704 15.793C8.33961 15.9255 8.51941 16 8.70689 16C8.89437 16 9.07417 15.9255 9.20674 15.793L12 12.9997L14.7933 15.793C14.9258 15.9255 15.1056 16 15.2931 16C15.4806 16 15.6604 15.9255 15.793 15.793C15.9255 15.6604 16 15.4806 16 15.2931C16 15.1056 15.9255 14.9258 15.793 14.7933L12.9979 12Z"
      fill={props.color}
    />
  </svg>
)
